//import Vue from 'vue'

import Cookies from 'js-cookie';
import URI from 'urijs';
import {gsap, TweenMax, Cubic, ScrollToPlugin} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

const CommonPlugin = {
  install (Vue, options) {

    Vue.mixin({
      data() {
        return {}
      },
      computed: {
      },
      mounted() {
      },
      methods: {
        $_showMoreCookie() {
          Cookies.set('member-showmore', true);
          Cookies.set('member-showmore-url', location.href);
        },
        $_checkShowMore() {
          if (Cookies.get('member-showmore')
            && Cookies.get('member-showmore-url') === location.href) {
            // すでにshow moreを開いてる
            return true;
          } else {
            return false;
          }
        },
        $_resetShowMoreCookie() {
          Cookies.remove('member-showmore');
          Cookies.remove('member-showmore-url');
        },
        $_setRatio(el) {
          if (!el) return;

          el.forEach((wrap) => {
            const iframe = wrap.querySelector('iframe');
            if (!iframe) return true;
            if (!iframe.getAttribute('width')
              || !iframe.getAttribute('height')) return true;

            const ratio = ((iframe.getAttribute('height') / iframe.getAttribute('width')) * 100);
            wrap.querySelector('span').style.paddingTop = `${ratio}%`;
          });
        },
        $_anchorFromUrl() {
          const u = new URI(location.href);
          const qs = u.query(true);

          if (qs['anchor']) {
            this.$_gotoAnchor(qs['anchor']);
          }
        },
        $_gotoAnchor(hash) {
          if (hash) {
            let adjust = 0;

            const el = document.getElementById(hash.replace('#', ''));
            const posY = this.$_getOffsetTop(el).top - adjust;

            TweenMax.to(window, 0.5, {
              scrollTo: {y: posY, autoKill: false},
              ease: Cubic.easeInOut
            });
          }
        },
        $_getOffsetTop(el) {
          let targetY = el.offsetTop;
          let parent = el.offsetParent;
          while (parent && parent != document.body) {
            targetY += parent.offsetTop;
            parent = parent.offsetParent;
          }
          return {top: targetY, parent: parent};
        },
        $_getOffset(el) {
          let targetY = el.offsetTop;
          let parent = el.offsetParent;
          while (parent && parent != document.body) {
            targetY += parent.offsetTop;
            parent = parent.offsetParent;
          }
          return {top: targetY, parent: parent};
        },
        $_getHash(el) {
          const tagname = el.tagName.toLowerCase();
          let hash = '';

          if (tagname === 'a') {
            hash = el.hash.replace('#', '');
          } else {
            //hash = el.querySelector('a').hash.replace('#', '');
            let parent = el.parentNode;

            while (parent && parent != document.body && parent.tagName.toLocaleLowerCase() != 'a') {
              parent = el.parentNode;
            }

            if (parent) {
              hash = parent.hash.replace('#', '');
            }
          }

          return hash;
        },
        $_random(min, max) {
          return Math.random() * (max - min) + min;
        },
        $_randomInt(min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        $_getBodyWidth() {
          return document.body.clientWidth || window.innerWidth;
        },
        $_currentScrollY() {
          return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        },
        /**
         * 楕円形の円周上の座標を返す
         * @param  degree  角度
         * @param  radiusX  横半径
         * @param  radiusY  縦半径
         * @returns {}  x, y を含んだオブジェクト
         */
        $_getOvalPosition(degree, radiusX, radiusY, centerX, centerY) {
          let obj = {};

          // 0〜360未満に丸める
          degree = (degree % 360 + 360) % 360;

          // ラジアンに変換
          const radian = degree * (Math.PI / 180);
          const cos = Math.cos(radian);
          const sin = Math.sin(radian);

          obj.x = (cos * radiusX) + centerX;
          obj.y = (sin * radiusY) + centerY;

          return obj;
        },
        /**
         * 円周上の x, y 座標を返す
         * @param  degree  角度
         * @param  radius  半径
         * @returns {}  x, y を含んだオブジェクト
         */
        $_getCirclePosition(degree, radius) {
          let obj = {};

          // 0〜360未満に丸める
          degree = (degree % 360 + 360) % 360;

          // ラジアンに変換
          const radian = degree * (Math.PI / 180);
          const cos = Math.cos(radian);
          const sin = Math.sin(radian);

          obj.x = cos * radius;
          obj.y = sin * radius;

          return obj;
        },
        // ラジアン = 角度 * Math.PI / 180
        $_deg2rad(degree) {
          return degree * (Math.PI / 180);
        },
        // 角度 = ラジアン * 180 / Math.PI
        $_rad2deg(radian) {
          return radian * (180 / Math.PI);
        },
        $_pos2dist(pos1, pos2) {
          return Math.sqrt(
            Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2)
          );
        },
        $_pos2radian(pos1, pos2) {
          return Math.atan2(pos2.y - pos1.y, pos2.x - pos1.x);
        }
      }
    });

  }
};

export default CommonPlugin